import { HeaderBannerController } from "./header-banner.controller";

export class HeaderBannerComponent {

  controller: any = HeaderBannerController;

  template: string = `
    <div class="header-banner-container"
      ng-mouseover="!$ctrl.isMobile() ? $ctrl.showBanner(true) : ''"
      ng-mouseleave="!$ctrl.isMobile() ? $ctrl.showBanner(false) : ''"
      ng-click="$ctrl.isMobile() ? $ctrl.showBanner() : ''">
      <div class="header-banner max-size">
        <img class="info-icon" cdn-path="/visa/icons/info_icon.png"></img>
        <span translate="wl.visa.infinite_cardholder_question"></span>
        <div class="mobile-show-banner" ng-show="$ctrl.isMobile()">
          <img class="chev-icon"
            cdn-path="/visa/icons/chev_down.png"
            ng-class="{ 'is-shown': $ctrl.bannerDescription }"></img>
        </div>
      </div>
      <div class="header-banner-content max-size" ng-class="{ 'is-shown': $ctrl.bannerDescription }">
        <div class="content">
          <div class="description-container">
            <div class="top-description" translate="wl.visa.infinite_cardholder_notification"> </div>
            <div translate="wl.visa.infinite_cardholder_information"> </div>
          </div>
          <div class="image-container">
            <img cdn-path="/visa/visa-card-face.png"></img>
          </div>
        </div>
      </div>
    </div>
  `;

}

angular.module("BookingApp").component("headerBanner", new HeaderBannerComponent());
